import * as plpStore from './plpstore.js';
import searchByParameterManager from './searchbyparametermanager.js';
import * as hashState from './hashstate.js';

export function createSearchData({
    location,
    history,
    fetch,
    searchByParameterManager,
    hashState,
    plpStore
}) {
    return function searchData(initialData, handleChange) {
        let manager = searchByParameterManager(initialData);
        let currentController = null;
        let currentURL = location.href;       

        const update = async (isRestoringFacetState=false) => {
            const content = await fetchContent(manager.toJSON());

            if (!content) {
                return;
            }

            if (typeof handleChange === 'function') {
                handleChange({
                    content,
                    isRestoringFacetState
                });
            }

            if (!isRestoringFacetState) {                
                currentURL = buildURLWithPageNumber(location, manager.getPageNumber());
    
                history.replaceState(history.state, '', currentURL);
            }
            
            plpStore.set({
                url: location.href,
                hash: hashState.buildHashStateString(manager.facetsToParameterString())
            });
        };

        async function fetchContent(jsonData) {
            if (currentController) {
                currentController.abort();
            }

            const controller = new AbortController();
            currentController = controller;

            try {
                const response = await fetch('/search/SearchByParameter?parameters=' + encodeURIComponent(jsonData), {
                    signal: controller.signal
                });

                if (response.redirected) {
                    location.href = response.url;
                    return null;
                }

                return await response.text();
            } catch (error) {
                if (error.name === "AbortError") {
                    return null;
                }

                throw error;
            } finally {
                if (currentController === controller) {
                    currentController = null;
                }
            }
        }

        const setSort = value => {
            manager.setSort(value);
            update();
        };

        const setSize = value => {
            manager.setSize(value);
            update();
        };

        const setPageNumber = value => {
            manager.setPageNumber(value);
            update();
        };

        const getPageNumber = manager.getPageNumber;
        const isCategory = manager.isCategory;
        const isKeyword = manager.isKeyword;
        const getCategoryId = manager.getCategoryId;
        const getKeywordSearchTerm = manager.getKeyword;
        const getActiveFacetNames = () => manager.getFacetEntries().map(([name]) => name);
        
        const addFacet = options => {
            manager.setFacet(options);
            update();
        };
        
        const removeFacet = options => {
            manager.removeFacet(options);
            update();
        };

        const state = plpStore.get();

        const inititalizeFromHashState = async (stateFromHash, search) => {
            const currentParams = new URLSearchParams(search);
            
            if (currentParams.has('page')) {
                manager.setPageNumber(+currentParams.get('page'));
            }
            
            if (stateFromHash) {
                manager.replaceFacetsFromParameterString(stateFromHash);
                        
                await update(true);
            }
        };

            
        if (hashState.containsFacetState(location.hash)) {
            inititalizeFromHashState(hashState.getStateFromHash(location.hash), location.search);
        } else if (state?.url === location.href && hashState.containsFacetState(state?.hash)) {
            inititalizeFromHashState(hashState.getStateFromHash(state.hash), location.search);
        } else {
            plpStore.set({
                url: location.href,
                hash: ''
            });
        }

        return {
            setSort,
            setSize,
            setPageNumber,
            getPageNumber,
            isCategory,
            isKeyword,
            getCategoryId,
            getKeywordSearchTerm,
            getActiveFacetNames,
            addFacet,
            removeFacet
        };
    };
}

const searchData = createSearchData({
    location: window.location,
    history: window.history,
    fetch: window.fetch,
    hashState,
    searchByParameterManager,
    plpStore
});

export default searchData;

export function buildURLWithPageNumber(location, pageNumber) {
    const params = new URLSearchParams(location.search);
    const pageKey = 'page';

    if (pageNumber > 1) {        
        params.set(pageKey, pageNumber);        
    } else {
        params.delete(pageKey);
    } 
       
    params.sort();

    return params.size > 0 ?
        `${location.pathname}?${params.toString()}`
        : location.pathname;
}